import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface GridSizeDTO {
  width: number;
}

export class GridSize {
  readonly isGridSizeGridSize: boolean = true;

  readonly width: number;

  static readonly constraints = {
    "width": {
      "minValue": 1,
      "maxValue": 10,
    }
  }

  constructor(
  width: number
  ) {
    GridSize.validateWidth(width);
    this.width = width;
  }

  static fromDTO(dto: GridSizeDTO): GridSize {
    const width = getInt32(dto, "width", InvalidGridSizeWidthError);
    return new GridSize(
      width
    );
  }

  toDTO(): GridSizeDTO {
    const dto: GridSizeDTO = {
        width: this.width
    };
    return dto;
  }
  private static validateWidth = (width: number): void => {
    if(width < 1) {
      throw new InvalidGridSizeWidthMinValueError(
        1,
        `Attribute width has value ${width}. Min value is 1.`
      );
    }
    if(width > 10) {
      throw new InvalidGridSizeWidthMaxValueError(
        10,
        `Attribute width has value ${width}. Max value is 10.`
      );
    }
  }
  
}

GridSize.prototype.toString = function toString(): string {
  return `GridSize(width='${this.width}')`;
};

export class InvalidGridSizeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSizeError";
  }
}
export class InvalidGridSizeWidthError extends InvalidGridSizeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSizeWidthError";
  }
}

export class InvalidGridSizeWidthMaxValueError extends InvalidGridSizeWidthError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSizeWidthMaxValueError";
  }
}

export class InvalidGridSizeWidthMinValueError extends InvalidGridSizeWidthError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSizeWidthMinValueError";
  }
}
